import { render } from "./ConversationMemberAvatars.vue?vue&type=template&id=2489d172&scoped=true"
import script from "./ConversationMemberAvatars.vue?vue&type=script&lang=js"
export * from "./ConversationMemberAvatars.vue?vue&type=script&lang=js"

import "./ConversationMemberAvatars.vue?vue&type=style&index=0&id=2489d172&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2489d172"]])

export default __exports__